export enum ETipoVinculo {
    VendedorClientes = 1,
    UsuarioVendedor = 2,
    UsuarioVendedorZona = 3,
}
